<div class="container">
  @for (message of messages; track message; let i = $index) {
    <app-message-card
      [messageInput]="message"
      [index]="i"
      [canSeeButtons]="
        (userService.getCurrentUser$() | async)?.roleName === USER_ROLE.ADMIN
      "
      (reload)="loadMessages()"
    ></app-message-card>
  }

  <!-- Commenting out for now since BE isn't done -->
  @if (
    messages.length < 2 &&
    (userService.getCurrentUser$() | async)?.roleName === USER_ROLE.ADMIN
  ) {
    <div class="ion-justify-content-end">
      <ion-button fill="outline" class="add-button" (click)="addMessage()">
        <div class="button-text">
          {{ DISPLAY.ADD_BANNER_BUTTON }}
        </div>
        <img src="assets/add-home.svg" />
      </ion-button>
    </div>
  }

  <div class="centered">
    <ion-row class="welcome-wrapper">
      <ion-col>
        <h2 class="welcome-title">
          {{ DISPLAY.TITLE }}
        </h2>
        <p class="welcome-text">
          {{ DISPLAY.LOGIN_NOTE }}
          <br />
          {{ DISPLAY.FUNCTION_NOTE }}
        </p>
      </ion-col>
    </ion-row>
    <ion-row>
      @for (card of CARD_TEXT; track card; let i = $index) {
        <ion-col class="home-col" size="3">
          <app-home-card
            [headerText]="card.HEADER"
            [buttonText]="card.BUTTON"
            [bodyText]="card.BODY"
            [imageSrc]="card.IMAGE"
            (buttonClick)="buttonClick(i)"
          >
          </app-home-card>
        </ion-col>
      }
    </ion-row>
  </div>
</div>
